import { TextField } from '@mui/material'
import { FieldDef } from '../types'

interface Props {
  field: FieldDef
  value: number
  onChange: (v: number) => void
}

export default function NumberWidget({ field, value, onChange }: Props) {
  return (
    <TextField
      type="number"
      label={field.label}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value === '' ? 0 : Number(e.target.value))}
      size="small"
      required={field.required}
      sx={{ maxWidth: 220 }}
    />
  )
}
